import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 2a7 7 0 00-7 7v3a6 6 0 006 6 1 1 0 100-2 4 4 0 01-4-4V9a5 5 0 015-5h6a5 5 0 015 5v3a4 4 0 01-4 4 1 1 0 100 2 6 6 0 006-6V9a7 7 0 00-7-7H9zm7.89 6.455a1 1 0 00-1.78-.91c-.37.725-.747 1.442-1.245 1.932-.262.259-.537.436-.865.498V8a1 1 0 10-2 0v4.975c-.328-.062-.603-.24-.865-.498-.498-.49-.874-1.207-1.244-1.932a1 1 0 00-1.782.91l.026.05c.34.667.847 1.66 1.597 2.397.584.576 1.34 1.018 2.268 1.089V21a1 1 0 102 0v-7.077-1.932c.929-.071 1.684-.513 2.268-1.088.75-.739 1.256-1.73 1.597-2.398l.026-.05z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
